var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.704 98.5916C76.9293 98.5916 98.9998 76.5211 98.9998 49.2958C98.9998 22.0705 76.9293 0 49.704 0C22.4787 0 0.408203 22.0705 0.408203 49.2958C0.408203 76.5211 22.4787 98.5916 49.704 98.5916Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0067 49.2953C30.8111 49.2953 29.0312 47.5154 29.0312 45.3198V42.1395C29.0312 39.9439 30.8111 38.1641 33.0067 38.1641C35.2023 38.1641 36.9821 39.9439 36.9821 42.1395V45.3198C36.9821 47.5154 35.2023 49.2953 33.0067 49.2953Z",
    fill: "#7D5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.008 38.1641C32.7357 38.1641 32.47 38.192 32.2129 38.2442V43.7297C32.2129 45.047 33.2808 46.1149 34.5982 46.1149C35.9155 46.1149 36.9834 45.047 36.9834 43.7297V42.1395C36.9834 39.9437 35.2038 38.1641 33.008 38.1641Z",
    fill: "#9C6846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4012 49.2953C64.2056 49.2953 62.4258 47.5154 62.4258 45.3198V42.1395C62.4258 39.9439 64.2056 38.1641 66.4012 38.1641C68.5968 38.1641 70.3767 39.9439 70.3767 42.1395V45.3198C70.3767 47.5154 68.5968 49.2953 66.4012 49.2953Z",
    fill: "#7D5046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4025 38.1641C66.1302 38.1641 65.8645 38.192 65.6074 38.2442V43.7297C65.6074 45.047 66.6754 46.1149 67.9927 46.1149C69.31 46.1149 70.3779 45.047 70.3779 43.7297V42.1395C70.3779 39.9437 68.5981 38.1641 66.4025 38.1641Z",
    fill: "#9C6846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7948 73.5472C33.3134 73.5472 32.8305 73.3734 32.4484 73.0223C31.6408 72.2785 31.5881 71.0214 32.3319 70.213C36.3665 65.8284 42.8591 63.2109 49.6965 63.2109C56.5371 63.2109 63.0284 65.8292 67.0612 70.2138C67.805 71.0214 67.7523 72.2792 66.9447 73.0223C66.1388 73.7662 64.8793 73.7157 64.1354 72.9051C60.8416 69.324 55.4437 67.1864 49.6964 67.1864C43.9505 67.1864 38.5526 69.324 35.2573 72.9058C34.8664 73.3316 34.3305 73.5472 33.7948 73.5472Z",
    fill: "#AA7346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8598 91.4381C29.6344 91.4381 7.56399 69.3677 7.56399 42.1424C7.56399 30.3524 11.7081 19.5335 18.6124 11.0508C7.5066 20.0896 0.408203 33.8628 0.408203 49.2981C0.408203 76.5235 22.4787 98.5939 49.704 98.5939C65.1395 98.5939 78.9127 91.4953 87.9517 80.3895C79.4688 87.2938 68.6499 91.4381 56.8598 91.4381Z",
    fill: "#FFD164"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.5916,
    height: 98.5916,
    fill: "white",
    transform: "translate(0.408203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadSmiley);
export default __webpack_public_path__ + "static/media/sad-smiley.b3f01d0f94b4f0476ca29008396aa3bd.svg";
export { ForwardRef as ReactComponent };